import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseReviewSectionLeadProps {
  publicCompanyLeadId?: string
  state?: string
  section: string
  onSuccess: () => void
  onError: () => void
}

export const useReviewSectionLead = ({
  publicCompanyLeadId,
  state,
  section,
  onSuccess,
  onError,
}: UseReviewSectionLeadProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewSectionLead'],
    mutationFn: async (data?: { description?: string }) => {
      const lead = {
        [section]: {
          last_review_attributes: {
            state,
            description: data?.description,
          },
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
